import { AdminHeader } from "@/components/AdminHeader";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Inbox } from "lucide-react";

const ROW = "border-[#E5DED5] hover:bg-[#F5EFE6]/50 transition-colors";

export default function LeadsTab() {
  const [leads, setLeads] = useState(null);

  useEffect(() => {
    api.get("/admin/leads").then((r) => setLeads(r.data)).catch(() => setLeads([]));
  }, []);

  if (leads === null) return <p className="text-muted-foreground font-ui">Loading leads…</p>;

  return (
    <div data-testid="admin-leads-tab">
      <AdminHeader testid="admin-header-leads" eyebrow="Sales" title="Leads" description={<span className="flex items-center gap-2"><Inbox size={15} className="text-[#C71E2E] shrink-0" /> {leads.length} {leads.length === 1 ? "inquiry" : "inquiries"} from the contact form</span>} />
      <div className="bg-white shadow-[0_8px_30px_rgba(0,0,0,0.04)] rounded-2xl overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow className="border-[#E5DED5] hover:bg-transparent">
              <TableHead>Name</TableHead>
              <TableHead>Email</TableHead>
              <TableHead>Phone</TableHead>
              <TableHead>Message</TableHead>
              <TableHead>Received</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {leads.length === 0 && (
              <TableRow className={ROW}>
                <TableCell colSpan={5} data-testid="leads-empty" className="text-muted-foreground font-ui py-10 text-center">
                  No leads yet — contact form submissions will appear here.
                </TableCell>
              </TableRow>
            )}
            {leads.map((l) => (
              <TableRow key={l.id} data-testid={`lead-row-${l.id}`} className={ROW}>
                <TableCell className="font-ui font-medium whitespace-nowrap">{l.name}</TableCell>
                <TableCell>
                  <a href={`mailto:${l.email}`} className="text-[#C71E2E] hover:underline font-ui">{l.email}</a>
                </TableCell>
                <TableCell className="whitespace-nowrap">
                  {l.phone ? (
                    <a data-testid={`lead-phone-${l.id}`} href={`tel:${l.phone}`} className="text-[#C71E2E] hover:underline font-ui">{l.phone}</a>
                  ) : (
                    <span className="text-muted-foreground">—</span>
                  )}
                </TableCell>
                <TableCell className="text-muted-foreground max-w-md"><p className="truncate">{l.message}</p></TableCell>
                <TableCell className="text-muted-foreground whitespace-nowrap">{new Date(l.created_at).toLocaleString()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
